<template>
  <div v-resize="resizeChatbox" class="message-item">
    <!-- question -->
    <template v-if="message.messagetype != 'replycomment'">
      <template v-if="value">
        <LivechatFacebookPostLink :value="value" />
      </template>

      <template v-if="message.questiontype">
        <template v-if="message.questiontype == 'ad_id'">
          <AdsData
            :adId="message.questiondata"
            class="text-xs-center small my-4"
            style="font-size: small"
          >
            <template v-slot="{ item }">
              <template v-if="item && item.creative && item.creative.title">
                {{ $t('this_message_was_replied_from_ads', { ad_id: message.questiondata }) }}
                {{ item.creative.title }}
              </template>
            </template>
          </AdsData>
          <div class="clearfix"></div>
        </template>
        <template v-else-if="message.questiontype == 'failed'">
          <!-- No question data -->
        </template>
        <div
          v-else-if="
            (message.questiontype != 'comment' ||
              (message.questiontype == 'comment' && message.questiondata)) &&
            message.questiontype != 'noreply' &&
            message.questiondata != '{image}'
          "
          class="receiver"
        >
          <div class="user">
            <template v-if="selectedUser && selectedUser.profile_pic">
              <v-avatar :size="15" color="grey lighten-4">
                <img :src="selectedUser.profile_pic" alt class="profile" />
              </v-avatar>
            </template>
          </div>
          <div
            :style="{ 'max-width': maxwidth ? maxwidth + 'px' : 'auto' }"
            class="message"
            style="position: relative"
          >
            <message-viewer
              v-model="parseQuestionMessage"
              :align="'left'"
              :channel="$store.state.livechat.app"
              :fontSize="'15px'"
              :messageId="messageId"
              :showProfile="false"
              :size="'small'"
            ></message-viewer>
            <!-- :align="value.answerby != '' || value.answerby == 'bot' ? 'right' : 'left'" -->
            <div align="left" style="height: 0.5em">
              <small style="position: relative; bottom: 1.3em">{{
                value.timestamp | DateFormat('DD/MM/YYYY HH:mm')
              }}</small>
            </div>
          </div>
          <div class="clearfix"></div>
        </div>
      </template>

      <!-- answer -->
      <div
        v-if="
          (value.answerby != '' || value.answerby == 'bot') &&
          parseAnswerMessage[0] &&
          parseAnswerMessage[0].length > 0 &&
          message.messagetype != 'noreply'
        "
        :class="{ bot: value.answerby == 'bot' }"
        class="sender"
      >
        <div v-if="message.questiontype && message.questiontype == 'failed'" class="pa-2">
          <v-tooltip bottom>
            <template v-slot:activator="{ on }">
              <v-icon class="red--text" small style="cursor: pointer" v-on="on">error</v-icon>
            </template>
            <span>{{ message.questiondata }}</span>
          </v-tooltip>
        </div>
        <div
          :style="{ 'max-width': maxwidth ? maxwidth + 'px' : 'auto' }"
          class="message"
          style="position: relative"
        >
          <template v-if="!hiddenChat">
            <message-viewer
              v-model="parseAnswerMessage"
              :align="value.answerby != '' || value.answerby == 'bot' ? 'right' : 'left'"
              :background="
                !['102052945584054', '106855151601601'].includes(livechat.pageid)
                  ? undefined
                  : '#ffa899'
              "
              :channel="$store.state.livechat.app"
              :fontSize="'15px'"
              :showProfile="false"
              :size="'small'"
            ></message-viewer>
          </template>
          <div align="right" style="height: 0.5em">
            <small
              v-if="!hiddenChat"
              :style="{ position: 'relative', bottom: hiddenChat ? '0' : '1.3em' }"
            >
              <template v-if="[...$store.state.bbqPage].includes(livechat.pageid)">
                <template v-if="value.userread && value.userread_timestamp">
                  {{ $t('read') }}
                </template>
              </template>
              {{ value.timestamp | DateFormat('DD/MM/YYYY HH:mm  -  ') }}
            </small>

            <template v-if="value.answerby == 'admin'">
              <small
                v-if="adminName"
                :style="{ position: 'relative', bottom: hiddenChat ? '0' : '1.3em' }"
                >{{ adminName }} <em v-if="hiddenChat" class="fas fa-arrow-down"></em
              ></small>
              <small v-else :style="{ position: 'relative', bottom: hiddenChat ? '0' : '1.3em' }"
                >admin <em v-if="hiddenChat" class="fas fa-arrow-down"></em
              ></small>
            </template>
            <template v-else>
              <small :style="{ position: 'relative', bottom: hiddenChat ? '0' : '1.3em' }"
                >Bot <em v-if="hiddenChat" class="fas fa-arrow-down"></em
              ></small>
            </template>
          </div>
        </div>
        <div :style="{ visibility: hiddenChat ? 'hidden' : 'visible' }" class="user">
          <v-avatar :size="15" color="grey lighten-4">
            <img
              :src="'https://graph.facebook.com/' + $store.state.livechat.pageid + '/picture'"
              alt
              class="profile"
            />
          </v-avatar>
        </div>
        <div class="clearfix"></div>
      </div>
    </template>
  </div>
</template>

<script>
import { mapGetters } from 'vuex'
import MessageViewer from '@/components/elements/MessageViewer'
import moment from 'moment'
import axios from 'axios'
import LivechatFacebookPostLink from './LivechatFacebookPostLink'
import AdsData from './AdsData'

export default {
  props: ['value', 'receiver', 'userAns', 'messageId', 'hiddenChat'],
  data: function () {
    return {
      message: this.value,
      isError: false,
      maxwidth: null
    }
  },
  components: {
    MessageViewer,
    AdsData,
    LivechatFacebookPostLink
  },
  filters: {
    dateFormat(v) {
      return moment(v).format('DD-MM-YYYY HH:mm')
    }
  },
  mounted() {
    if (this.value.adminid && /^\d+$/.test(this.value.adminid)) this.getFbName(this.value.adminid)
  },
  computed: {
    adminName() {
      var vm = this
      if (vm.value.adminid) {
        if (/^\d+$/.test(vm.value.adminid)) {
          var result = vm.$store.state.facebook_users_name.find((el) => el.id == vm.value.adminid)
          if (result) return result.name
        } else {
          return vm.value.adminid
        }
      } else return ''
    },
    ...mapGetters({
      selectedBot: 'selectedBot',
      selectedUser: 'getCurrentUser',
      livechat: 'livechat'
    }),
    isReceiver: function () {
      // sender == admin and bot
      // receiver == customer
      return this.value.answerby == ''
    },
    parseAnswerMessage: function () {
      var vm = this
      var messages = [[]]
      var chatdetail = vm.message.messagedata
      var chattype = vm.message.messagetype
      // console.log(chattype, chatdetail)

      if (chattype == 'template') {
        if (vm.message.intent == '{welcome}') {
          messages = [
            [
              {
                type: 'welcome_message'
              }
            ]
          ]
        } else {
          try {
            messages = [
              [
                {
                  type: 'generic',
                  data: JSON.parse(chatdetail),
                  ratio: vm.message.ratio == 'horizontal' ? 'horizontal' : 'square'
                }
              ]
            ]
          } catch (error) {
            messages = [
              [
                {
                  type: 'text',
                  text: chatdetail
                }
              ]
            ]
          }
        }
      } else if (chattype == 'text' && chatdetail.includes('{welcome_message}')) {
        messages = [
          [
            {
              type: 'welcome_message'
            }
          ]
        ]
      } else if (chattype == 'json' || chattype == 'replyinbox') {
        try {
          var message = JSON.parse(chatdetail)
          messages[0] = message
        } catch (error) {
          vm.isError = true
        }
      } else if (chattype == 'noreply' || chatdetail == '') {
        vm.$set(vm.message, 'messagetype', 'noreply')
      } else {
        try {
          var newGroup = []
          // console.log(chatdetail)
          var group = chatdetail.split('||')
          $.each(group, function (index, messages) {
            var newMessage = []
            var group_messages = messages.split('#nl')
            $.each(group_messages, function (index, message) {
              var type = 'text'
              if (!isNaN(message)) {
                newMessage.push({
                  type: 'text',
                  text: message
                })
              } else if (vm.isJsonParseable(message)) {
                var messageParsed = JSON.parse(message)
                newMessage.push({
                  text: messageParsed.text,
                  buttons: messageParsed.buttons,
                  type: 'button'
                })
              } else if (vm.isImageURL(message)) {
                newMessage.push({
                  type: 'image',
                  image_url: message
                })
              } else {
                newMessage.push({
                  type: 'text',
                  text: message
                })
              }
            })
            newGroup.push(newMessage)
          })
          messages = newGroup
        } catch (error) {}
      }

      return messages
    },
    parseQuestionMessage: function () {
      var vm = this
      var messages = [[]]
      var chatdetail = vm.message.questiondata
      var raw_message = vm.message.raw_message
      var chattype = vm.message.questiontype
      if (chattype) {
        if (chattype == 'template') {
          if (vm.message.intent == '{welcome}') {
            messages = [
              [
                {
                  type: 'welcome_message'
                }
              ]
            ]
          } else {
            messages = [
              [
                {
                  type: 'generic',
                  data: JSON.parse(chatdetail),
                  ratio: vm.message.ratio == 'horizontal' ? 'horizontal' : 'square'
                }
              ]
            ]
          }
        } else if (chattype == 'json') {
          try {
            // messages = JSON.parse(chatdetail)
            var message = JSON.parse(chatdetail)
            messages[0] = message
          } catch (error) {
            vm.isError = true
          }
        } else if (chattype == 'noreply' || chatdetail == '') {
          vm.$set(vm.message, 'questiontype', 'noreply')
        } else if (chattype == 'image') {
          messages = [
            [
              {
                type: 'image',
                image_url: chatdetail
              }
            ]
          ]
        } else if (chattype == 'video') {
          if (vm.message.intent == '{video}') {
            messages = [
              [
                {
                  type: 'video',
                  video_url: chatdetail
                }
              ]
            ]
          }
        } else if (chattype == 'audio') {
          if (vm.message.intent == '{audio}') {
            messages = [
              [
                {
                  type: 'audio',
                  audio_url: chatdetail
                }
              ]
            ]
          }
        } else if (chattype == 'file') {
          if (chattype == 'file') {
            messages = [
              [
                {
                  type: 'file',
                  data: chatdetail,
                  filename: vm.message.intent
                }
              ]
            ]
          }
        } else if (chattype == 'follow') {
          messages = [
            [
              {
                type: 'text',
                text: 'Get Started'
              }
            ]
          ]
        } else {
          var newGroup = []
          try {
            var group = raw_message ? raw_message.split('||') : chatdetail.split('||')
            $.each(group, function (index, messages) {
              var newMessage = []
              var group_messages = messages.split('#nl')
              $.each(group_messages, function (index, message) {
                var type = 'text'
                if (!isNaN(message)) {
                  newMessage.push({
                    type: 'text',
                    text: message
                  })
                } else if (vm.isJsonParseable(message)) {
                  var messageParsed = JSON.parse(message)
                  console.log(messageParsed)
                  // Customize for deeple payload
                  if (messageParsed.displayText || messageParsed.categoryName) {
                    newMessage.push({
                      type: 'text',
                      text: messageParsed.displayText || messageParsed.categoryName
                    })
                  } else {
                    // zwiz
                    newMessage.push({
                      text: messageParsed.text,
                      buttons: messageParsed.buttons,
                      type: 'button'
                    })
                  }
                } else {
                  newMessage.push({
                    type: 'text',
                    text: message
                  })
                }
                // else if (vm.isURL(message)) {
                //   newMessage.push({
                //     type: 'image',
                //     image_url: message
                //   })
                // }
              })
              newGroup.push(newMessage)
            })
            messages = newGroup
          } catch (error) {
            newMessage.push({ type: 'text', text: chatdetail })
          }
        }
      }
      return messages
    }
  },
  methods: {
    resizeChatbox() {
      var vm = this
      vm.$nextTick(function () {
        vm.maxwidth = document.getElementById('chatbox').clientWidth - 10
      })
    },
    async getFbName(userid) {
      var vm = this
      var fbusersname = vm.$store.state.facebook_users_name
      if (!fbusersname.some((el) => el.id == userid))
        var result = await axios.get(
          `https://graph.facebook.com/${userid}?fields=name&access_token=${vm.selectedBot.page_access_token}`
        )
      if (result) {
        vm.$store.state.facebook_users_name.push(result.data)
      }
    }
  },
  watch: {
    value: function (newVal, oldVal) {
      this.message = newVal
    }
  }
}
</script>

<style lang="scss" scoped>
.message-item {
  margin: 5px;
}

.receiver {
  display: flex;
  white-space: nowrap;

  .user {
    margin-right: 5px;
  }
}

.sender {
  display: flex;
  justify-content: flex-end;
  white-space: nowrap;

  .user {
    margin-left: 5px;
  }
}

.messageTime {
  position: absolute;
  bottom: -7px;
  font-size: 8px;
}
</style>



// WEBPACK FOOTER //
// src/components/view/livechat/livechat-message.vue